import React from "react";
import principal from "../../assets/principal001.jpeg";
import leftQuote from "../../assets/quote (1).png";
import rightQuote from "../../assets/left (1).png";

const PhilosophySection = () => {
  return (
    <section className="flex justify-center bg-custom-pink p-8 lg:p-24 text-white">
      <div className="flex flex-col md:flex-row items-center mx-auto justify-between w-full lg:max-w-[1400px]">
        {/* Left Side: Image */}
        <div className="md:w-1/2 w-full relative">
          <img
            src={leftQuote}
            alt="Left Quote"
            className="absolute top-0 left-0 w-8 h-8 md:w-12 md:h-12 lg:w-28 lg:h-28 -translate-x-0 -translate-y-16"
          />
          <img
            src={principal}
            alt="Principal"
            className="w-full lg:w-[calc(110%)] h-auto lg:aspect-[550/371] object-cover rounded-[20px] mb-12 md:mb-0"
          />
        </div>

        {/* Right Side: Text */}
        <div className="lg:mt-24 lg:mr-8 text-black relative md:w-1/2 w-full">
          <div
            className="relative mt-12 lg:mt-0 p-8 lg:p-12 w-full lg:w-[calc(100%)] lg:aspect-[550/371] bg-white rounded-[20px] flex flex-col justify-center"
            style={{ transform: "translateX(-12.5px)" }}
          >
            {/* Section Heading */}
            <h2 className="text-2xl lg:text-3xl font-bold text-pink-700 mb-6">
              Message From Principal
            </h2>

            {/* Paragraph */}
            <p className="text-lg leading-relaxed tracking-wide mb-6">
              JRIIT is guided by a well-defined philosophy and core values. The
              Institute’s philosophy is to become an agent of change in the
              public and private sectors by offering quality, market-driven
              academic and professional training and consultancy services. Our
              core values include customer focus, academic freedom,
              accountability, competence, excellence, fairness, gender equity,
              and diversity, as well as integrity.
            </p>

            {/* Signature */}
            <h3 className="font-bold text-pink-700 text-xl text-right">
              Mr. Lukumay
            </h3>

            {/* Right quote */}
            <img
              src={rightQuote}
              alt="Right Quote"
              className="absolute bottom-0 right-0 w-8 h-8 md:w-12 md:h-12 lg:w-28 lg:h-28 translate-x-0 translate-y-16"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
